import EtablissementMuteco from "./EtablissementMuteco";

export default EtablissementMuteco;
